export const isProduction = location.hostname === 'm.lizhiweike.com' || location.hostname === 'm1.lizhiweike.com'

export const Config = isProduction ? {
	BASE_URL: 'https://apiv1.lizhiweike.com'
} : {
	BASE_URL: 'https://apiv1.lizhiweike.com'
}
